/**
 * Sums `total` and `savings` across all entries in the per-line map produced by `useCartPrices`.
 *
 * @param productPrices - Keys are stable line ids; values match `PriceInfo` from `useCartPrices`.
 */
export function aggregateCartLines(
	productPrices: Record<string, { total: number; savings: number }>
): { totalAll: number; savingsAll: number } {
	const values = Object.values(productPrices)
	return {
		totalAll: values.reduce((s, p) => s + p.total, 0),
		savingsAll: values.reduce((s, p) => s + p.savings, 0)
	}
}

/**
 * Pre-discount list total for strikethrough when every line has reported and aggregate savings are positive.
 *
 * @param pricesLoaded - Typically `useCartPrices().pricesLoaded`.
 * @param totalAll - Sum of payable line totals.
 * @param savingsAll - Sum of per-line savings; must be positive to return a list price.
 */
export function listPriceWhenDiscounted(
	pricesLoaded: boolean,
	totalAll: number,
	savingsAll: number
): number | undefined {
	return pricesLoaded && savingsAll > 0 ? totalAll + savingsAll : undefined
}
